import { SkeletonBone } from "../components/ui/skeleton";
import { WorkspaceSkeletonForm } from "../components/workspace/skeletons/WorkspaceSkeletonForm";

export function RouteLoadingFallback() {
  return (
    <div
      className="workspace-enter mx-auto flex w-full max-w-[1077px] flex-col gap-8 px-4 py-6"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading workspace"
    >
      <div className="flex flex-col gap-4" aria-hidden>
        <SkeletonBone className="h-6 w-32 rounded-full" />
        <SkeletonBone className="h-12 w-2/3 max-w-xl" />
        <SkeletonBone className="h-5 w-1/2 max-w-md" />
      </div>
      <div
        className="grid grid-cols-1 gap-4 md:grid-cols-3"
        aria-hidden
      >
        <SkeletonBone className="h-24 rounded-xl" />
        <SkeletonBone className="h-24 rounded-xl" />
        <SkeletonBone className="h-24 rounded-xl" />
      </div>
      <WorkspaceSkeletonForm fields={3} />
    </div>
  );
}
